import type { CourseDto } from "../../shared/CourseDto";
import type { IApiSearchResponse } from "../../shared/IApiSearchResponse";
import type { CourseSearchCommand } from "../command/CourseSearchCommand";
import type { ICourseRepository } from "../interfaces/ICourseRepository";
import type { CourseLessonDto } from "../../shared/CourseLessonDto";

export class CourseService  {
  readonly repo: ICourseRepository;
  constructor(repo: ICourseRepository) {
    this.repo = repo;
  }
  async getById(courseId: number): Promise<CourseDto | null> {
    return this.repo.findById(courseId);
  }
  async getLessons(courseId: number): Promise<CourseLessonDto[]>{
    return this.repo.getLessons(courseId)
  }
  async getAllForCategory(categoryId: number): Promise<CourseDto[]> {
    console.log(categoryId)
    // todo: use search method to get all courses of a category. Not required right now.
    throw new Error("Method not implemented.");
  }
  async search(cmd: CourseSearchCommand): Promise<IApiSearchResponse<CourseDto>> {
    return this.repo.search(
      cmd.courseCategoryId,
      cmd.search,
      cmd.page,
      cmd.perPage,
      cmd.sortBy,
      cmd.sortDesc,
    );
  }
}
